import { __ } from "@wordpress/i18n";
import React from 'react';
import Hint from '../components/Hint/Hint';
import InfoBox from "../components/InfoBox/InfoBox";
import Switch from '../components/Switch/Switch';
import { useMenu } from "../contexts/MenuContext";
import withForm from '../layouts/withForm';
const SecurityLoginSecurity = ({handleChange}) => {
    const {
        settingData, 
    } = useMenu();

    return (
        <>
            <div className="setting-unit pb-30 mb-30">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Login page URL", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Set the new URL where your users will need to login from now on.", "ultimate-security")}</p>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="bottom" content={__("Set the new url", "ultimate-security")}/>
                                    <div className="d-flex align-items-center gap-2">
                                        <span>{window.location.origin}</span>
                                        <span className="w-130">
                                            <input 
                                                className="form-control"
                                                type="text" 
                                                value={settingData?.security?.['login_security']?.custom_login_url}
                                                onChange={(e)=> handleChange('security.login_security.custom_login_url', e.target.value)}
                                            />
                                        </span>                                            
                                        <span>/</span>
                                    </div>
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <p className="pl-body text-text">{__( "Specify the URL to redirect users to access new login page.", "ultimate-security" )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-30 mb-30 border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Old login page URL redirect", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Specify the URL to redirect users who try to access the old login page.", "ultimate-security")}</p>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">

                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="bottom" content={__("Set the redirect URL", "ultimate-security")}/>
                                    <div className="d-flex align-items-center gap-2">
                                        <span>{window.location.origin}</span>
                                        <span className="w-130">
                                            <input 
                                                className="form-control"
                                                type="text" 
                                                value={settingData?.security?.['login_security']?.custom_login_redirect}
                                                onChange={(e)=> handleChange('security.login_security.custom_login_redirect', e.target.value)}
                                            />
                                        </span>                                            
                                        <span>/</span>
                                    </div>
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <p className="pl-body text-text">{__( "Redirect anyone Who tries to access the default WordPress login page URL to the above configured URL.", "ultimate-security" )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-30 mb-30 border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Show a consent message on the login page?", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Enable a new checkbox on the login page to request user consent for the login process.", "ultimate-security")}</p>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="bottom" content={__("Enable/disable consent checkbox", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable consent message on login page", "ultimate-security")}</h6>
                                </div>
                                <div className="content-below-with-hint">                                    
                                    <p className="pl-body text-text">{__( "Enable this if you want to show the consent checkbox and message for the login option.", "ultimate-security" )}</p>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.login_security.current_banner_content_enable"
                                    checked={settingData?.security?.['login_security']?.current_banner_content_enable} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Consent message", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Set the text for the consent message.", "ultimate-security")}</p>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="bottom" content={__("Set the consent text message", "ultimate-security")}/>
                                    <textarea 
                                        className="form-control"
                                        value={settingData?.security?.['login_security']?.current_banner_content}
                                        onChange={(e)=> handleChange('security.login_security.current_banner_content', e.target.value)}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <InfoBox className="small-infobox" title={__( "Note", "ultimate-security" )} content={__( "use the following shortcode to display this notice text on any page", "ultimate-security" ) + " [mls-gdpr-banner]"} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </>
    )
}
export default withForm(SecurityLoginSecurity, 'security.login_security');